import bar from 'daisy-chart/src/layouts/bar';
import data from './data/consumer_price.json';

bar().data(data)
  .name('bar')
  .container('#daisy-example')
  .dimensions(['년도', '종류'])
  .measures([{field: '지수', op: 'mean'}])
  .axis('x').axis('y')
  .legend(true)
  .render();


// WEBPACK FOOTER //
// ./js/examples/groupedBar.js